import type { Option } from '@branchjs/neo-components';
import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdatePartner = new ReduxAsyncAction<'UPDATE_PARTNER', Option, { partner: Option }>('UPDATE_PARTNER');

UpdatePartner.registerRequest(async (partner: Option) => {
  return { partner };
});

export const UPDATE_PARTNER = UpdatePartner.actionNamespaceConstants;
export const updatePartner = UpdatePartner.request;

export type UpdatePartnerResponseAction = Action<typeof UPDATE_PARTNER.response> & {
  data: { partner: Option };
};
